// ─────────────────────────────────────────────────────────────────────────────
// SignInError — shown instead of the app when Okta's redirect carries ?error=.
//
// Rendered outside the router and AuthGuard on purpose: the user has no session
// and must not be sent back to Okta automatically (see lib/loginError.ts).
// ─────────────────────────────────────────────────────────────────────────────
import { REQUEST_ACCESS_URL, type LoginError } from '@/lib/loginError'
import { cfg } from '@/lib/runtimeConfig'

export function SignInError({ error }: { error: LoginError }) {
  const denied = error.error === 'access_denied'
  // The request-access entry assigns the prod Okta app only.
  const nonProd = cfg('environment') !== 'prod'

  return (
    <div className="empty" style={{ paddingTop: 80 }}>
      <h3>{denied ? "You don't have access to EntCat" : "Couldn't sign you in"}</h3>
      <p style={{ color: 'var(--wl-fg-muted)', maxWidth: 440, textAlign: 'center' }}>
        {denied
          ? 'Your Okta account is not assigned to EntCat. Request access, then try again once it is granted.'
          : (error.description ?? error.error)}
      </p>
      {denied && nonProd && (
        <p style={{ color: 'var(--wl-fg-muted)', maxWidth: 440, textAlign: 'center' }}>
          This is a non-production environment. That request grants production access
          only; ask the Solution Architecture team for NonProd access.
        </p>
      )}
      <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
        {denied && (
          <a className="btn key" href={REQUEST_ACCESS_URL}>
            {nonProd ? 'Request production access' : 'Request access'}
          </a>
        )}
        <a className={denied ? 'btn' : 'btn key'} href={`${window.location.origin}/`}>
          Try again
        </a>
      </div>
    </div>
  )
}
